import { StageDetails } from "../../types/tournament";
import { ConfirmDialog } from "../../ui";

type DeleteStageDialogProps = {
  stage: StageDetails;
  isOpen: boolean;
  onClose: (update?: boolean) => void;
};

// The page does the delete when this closes with update = true.
const DeleteStageDialog = (props: DeleteStageDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    onClose={(confirmed) => props.onClose(confirmed || undefined)}
    onConfirm={() => {}}
    title="Are you sure?"
    message="This action cannot be undone. If you delete this stage, you will lose all details."
    confirmLabel="Delete"
  />
);

export default DeleteStageDialog;
